import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

  {/* <React.StrictMode>이거있으면 두번실행됨 다만 두번하면서 오류도잡ㅇ준다함 
    </React.StrictMode>*/}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<App />


    
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
